exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-card[data-v-16ac4e00]{\n    border-bottom: 4px solid #eabd75;\n}\n", ""]);

// exports
